import React from 'react';
import { LoadingSlate } from 'components/Gamma/VideoPlayer/Slate/LoadingSlate';
import { ExpiredSlate } from 'components/Gamma/VideoPlayer/Slate/ExpiredSlate';

/**
 * Select which slate should be shown given the current state
 * @param {object} props
 * @param {boolean} props.isPaused whether the video is paused
 * @param {boolean} props.isExpired whether the video is expired
 * @param {boolean} props.isHidden whether the video is explicitly hidden
 * @param {boolean} props.hasPlaybackStarted whether the
 * video has started at all for the current video, regardless of whether it's
 * currently paused
 */
export function Slate({
  isPaused,
  isExpired,
  isHidden,
  hasPlaybackStarted,
}) {
  if (isHidden) {
    return null;
  }
  if (isExpired) {
    return <ExpiredSlate />;
  }

  if (!hasPlaybackStarted && !isPaused) {
    return (
      <LoadingSlate />
    );
  }
  return null;
}
